import ServiceCRUD from 'services/ServiceNPS';
import { apiChatTS, apiNps } from '../http';

class SatisfactionSurvey extends ServiceCRUD {
  constructor() {
    super('configuration/survey');
  }

  getSurveyGeneralConfigurations() {
    return apiChatTS.get('/configurations/general/surveys');
  }

  updateSurveyGeneralConfigurations(data) {
    return apiChatTS.patch('/configurations/general/surveys', data);
  }

  fetchReports = (data) => {
    return apiNps.post(`reports/survey/analitic`, data);
  };
}

export default new SatisfactionSurvey();
